// Crossfading hero carousel: autoplay, dot navigation, swipe, pause on hover/focus.
class SHeroSlider extends HTMLElement {
  #ac;
  #timer;
  #index = 0;
  #startX = null;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    const slides = this.#slides();
    if (slides.length < 2) return;

    this.addEventListener('command', (event) => {
      if (event.command !== '--go') return;
      this.#go(Number(event.source?.dataset.index) || 0);
      this.#start();
    }, opts);

    this.addEventListener('pointerdown', (event) => { this.#startX = event.clientX; }, opts);
    this.addEventListener('pointerup', (event) => {
      if (this.#startX === null) return;
      const delta = event.clientX - this.#startX;
      this.#startX = null;
      if (Math.abs(delta) < 40) return;
      const rtl = getComputedStyle(this).direction === 'rtl';
      const forward = rtl ? delta > 0 : delta < 0;
      this.#go(this.#index + (forward ? 1 : -1));
      this.#start();
    }, opts);

    this.addEventListener('pointerenter', () => this.#stop(), opts);
    this.addEventListener('pointerleave', () => this.#start(), opts);
    this.addEventListener('focusin', () => this.#stop(), opts);
    this.#go(0);
    this.#start();
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.#stop();
  }

  #slides() {
    return [...this.querySelectorAll('[data-hero-slide]')];
  }

  #start() {
    this.#stop();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const interval = Number(this.dataset.interval) || 6000;
    this.#timer = setInterval(() => this.#go(this.#index + 1), interval);
  }

  #stop() {
    clearInterval(this.#timer);
  }

  #go(target) {
    const slides = this.#slides();
    this.#index = (target + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      const active = i === this.#index;
      slide.toggleAttribute('data-active', active);
      slide.toggleAttribute('inert', !active);
      slide.setAttribute('aria-hidden', String(!active));
    });
    this.querySelectorAll('[data-hero-dot]').forEach((dot, i) => {
      dot.setAttribute('aria-current', String(i === this.#index));
    });
  }
}

customElements.define('s-hero-slider', SHeroSlider);
